

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import "../../../assets/css/HTML.scss"
import { ALIGN, ILandingSection, LANDING_TYPE_CONTENT, TEXT_ALIGN, WriterContent } from "../../../data/interfaces"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import WriterPrimitive from "../primitive/WriterPrimitive"
import LinkContainer from "../useful/LinkContainer"
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface IWriterProps {
   section: ILandingSection
   data: WriterContent 
}
const Writer = ({data, ...props}: IWriterProps): JSX.Element => {
    const {position}          = usePosition(data)
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    
    const [gap]             = useState<string>(getCssDemention( data.gap, "20px" ))
    const [height, setHeight]       = useState<string>(getCssDemention( position.height || data.height, "fit-content" ))
    const [width]                   = useState<string>(getCssDemention( position.width || data.width, "100%" ))
    const [padding]                 = useState<string>(getCssDemention( data.padding, "0" ))
    const [borderRound]             = useState<string>(getCssDemention( data.incutBorder?.borderRound?.border, "0" ))
      
    useEffect(() => {
        addCSSClass(
            `landing-writer-${data.id}`,
            `.landing-writer-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                text-align:${ TEXT_ALIGN[ data.text_align || ALIGN.START] }; 
                max-height: ${ height };
                height: ${ height };
                ${ data.text_size ? `font-size: ${ data.text_size }px;` : "" }
                ${ data.text_color ? `color: ${ data.text_color }` : "" };
                ${ data.font ? `font-family: ${data.font}` : "" };
                transition: 400ms all ease-out;
                background-color: ${data.background || "transparent"};
                padding: ${padding};
                z-index:1;
                & > div {
                    column-gap:${gap};
                }
                .mast__text {
                    ${ data.font ? `font-family: ${data.font }!important;` : ""}
                    ${ data.text_size   ? `font-size: ${ data.text_size }px!important;` : "" }
                }
            } 
            .link-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: 100%;
                width: ${width};
                max-height: ${ height };
                height: ${ height };
                z-index:1;
            } 
            `
        )
        
        return () => {
            removeCSSClass(`landing-writer-${data.id}`)
        }
    },[ data, height, padding, borderRound ])
 
    return <div className={`pe-writer-container landing-content-container landing-writer-${data.id}`} data-type={data.type} data-content-id={data.id}>
        {
            !!data.text
                ?
                <>
                    <LinkContainer
                        link_url={data.link_url}
                        link_target={data.link_target}
                        className={`link-${data.id}`}
                        {...{
                            "data-primitive-type": LANDING_TYPE_CONTENT.WRITER 
                        }}
                    >
                        <WriterPrimitive
                            primitive={ {
                                ...(data ),
                                section: props.section,  
                                className: `${data.className} `
                            } as any }
                        />
                    </LinkContainer> 
                    <DataContentEditor data={data} section={props.section}  />
                </>
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} `
                        },
                    }, 
                    ...props 
                }} />
        }
        
    </div>
}
export default Writer

export const getDifferent = (type: string): number => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
        case LANDING_TYPE_CONTENT.HTML:
            return 0
        default: 
            return 40 
    }
}